<template>
    <div class="innerBox">
  
      <h1 class="mb-3">Outstanding Estimation Sparepart</h1>
  
      <panel class="border border-secondary" :noExpand="true">
        <template slot="header">
          <h4 class="panel-title">Filter</h4>
        </template>
        <div class="row outerBox filterBox" style="padding:0 25%">
          <div class="col row">
            <div class="col-md-6" :class="mobile ? 'pt-20' : ''">
              <label for="partshopCode">Work Order Code</label>
              <input type="text" class="form-control" placeholder="Ketik work order code" style="height: 43px;" v-model="filter.work_order_code">
            </div>
            <div class="col-md-6" style="display: flex; flex-direction: column-reverse" :class="mobile ? 'pt-20' : ''">
              <button type="button" class="btn btn-primary" style="height:38px; margin-bottom:0.5%" @click="vue_universal_table.update++">Filter</button>
            </div>
          </div>
        </div>
      </panel>
  
      <!-- <vue-universal-table
        api_url="/api/v1/workorder/listing/outstanding-estimations/sparepart"
        :fields="vue_universal_table.fields"
        :special_buttons="vue_universal_table.special_buttons"
        :disable_sort="true"
        :update="vue_universal_table.update"
        :filter="filter"
        :process_data="vue_universal_table.process_data"
        :export_config="vue_universal_table.export_config"
      ></vue-universal-table> -->
      <table class="table text-center" v-if="reloadTable">
        <thead>
          <th colspan="2">No.</th>
          <th colspan="1">Nomor Work Order</th>
          <th colspan="1">Nomor Polisi Mobil</th>
		  <th colspan="1">Waktu Dibuat</th>
          <th><i class="fa fa-cog"></i></th>
        </thead>
        <tbody v-for="(dat , index) in data " :key="index">
          <tr>
            <td colspan="2">{{index + 1}}</td>
            <td colspan="1">{{dat.work_order_code}}</td>
            <td colspan="1">{{dat.no_pol}}</td>
			<td colspan="1">{{moment(dat.created_at).format('MMM DD, YYYY HH:mm')}}</td>
            <td>
              <button v-if="!dat.show" class="btn btn-secondary" style="border-radius:20px" @click="showSpareparts(dat.work_order_code , index)"><i class="fa fa-arrow-down"></i></button>
              <button v-else class="btn btn-secondary" style="border-radius:20px" @click="dat.show = false;reloadTable = false;reloadTable =true"><i class="fa fa-arrow-up"></i></button>
            </td>
          </tr>
          <template v-if="dat.sparepartList && dat.show" >
            <tr style="background-color:#FFFFE0">
              <th>No.</th>
              <th>Sparepart Name</th>
              <th>Part Description</th>
              <th>Quoted</th>
              <th>Ordered</th>
              <th>Estimation Date</th>
            </tr>
            <tr style="background-color:#FFFFE0" v-for="(sparepart , index) in dat.sparepartList" :key="index">
              <td>{{index + 1}}</td>
              <td>{{sparepart.name}}</td>
              <td>{{sparepart.part_number}}</td>
              <td v-if="sparepart.supplier" style="color:green">✔</td>
			  <td v-else style="color:red">✘</td>
              <td v-if="sparepart.ordered" style="color:green">✔</td>
			  <td v-else style="color:red">✘</td>
              <td>{{moment(sparepart.created_at).format('MMM DD, YYYY HH:mm')}}</td>
            </tr>
          </template>
          
        </tbody>
      </table>
	  <div class="row">
			<div :class="{ 'col-4': !mobile }"></div>
			<div style="padding: 20px" :class="mobile ? 'col' : 'col-4'">
				<nav>
					<ul class="pagination" style="justify-content:center">
						<li
							class="page-item"
							:class="{ disabled: config.current_page <= 1 }"
							@click="changePage(1)"
						>
							<span class="page-link">&laquo;</span>
						</li>
						<li
							class="page-item"
							:class="{ disabled: config.current_page <= 1 }"
							@click="changePage(5)"
						>
							<span class="page-link">&lsaquo;</span>
						</li>
						<li class="page-item pageNumber" style="cursor:pointer">
							<span class="page-link" style="color:black">
								<span style="font-weight: bold !important">{{
									config.last_page < 1
										? 0
										: config.current_page
								}}</span>
								of {{ config.last_page }}
							</span>
						</li>
						<li
							class="page-item"
							:class="{
								disabled:
									config.current_page >= config.last_page,
							}"
							@click="changePage(6)"
						>
							<span class="page-link">&rsaquo;</span>
						</li>
						<li
							class="page-item"
							:class="{
								disabled:
									config.current_page >= config.last_page,
							}"
							@click="changePage(10)"
						>
							<span class="page-link">&raquo;</span>
						</li>
					</ul>
				</nav>
			</div>
		</div>
  
    </div>
  </template>
  
  <script>  
	import moment from 'moment'
    export default {
      data () {
        return {
			moment,
			mobile : this.isMobile(),
			filter : {
				work_order_code : '',
				type : 'WO'
			},
			reloadTable : true,
			data : null,
			vue_universal_table : {
				fields : [
					{
						title : 'Work Order ID',
						variable : 'work_order_code'
					},
					{
						title : 'No Polisi Mobil',
						variable : 'no_pol'
					},
					{
						title : 'Sparepart',
						variable : 'name'
					},
					{
						title : 'Part Description',
						variable : 'part_number'
					},
					//{
					//title : 'Supplier',
					//variable : 'supplier_name'
					//},
					{
						title : 'Quoted',
						variable : 'supplier',
						style_condition : {
						'✔' : 'color:green',
						'✘' : 'color:red'
						}
					},
					{
						title : 'Ordered',
						variable : 'ordered',
						style_condition : {
						'✔' : 'color:green',
						'✘' : 'color:red'
						}
					},
					{
						title : 'Dibuat Pada',
						variable : 'created_at'
					},
				],
				special_buttons : ['exportToExcel'],
				update : 0,
				export_config : {
				name : 'Outstanding Estimation',
				type : 'xlsx',
				all : true
				},
				process_data : `
				for (var i in data) {
					data[i].supplier = data[i].supplier ? '✔' : '✘'
					data[i].ordered = data[i].ordered ? '✔' : '✘'
				}
				`,
			},
			}
      },
      mounted () {
        this.generateData()
      },
      methods : {
		showSpareparts(wo_code , index) {
			let data = this.data.find(x => x.work_order_code == wo_code)
			if(data.sparepartList) {
				data.show = true
				this.reloadTable = false
				this.reloadTable = true
				return
			}

			let createQs = this.getQs(this.filter , true)
			createQs += `type=Details&work_order_code=${wo_code}`
			this.$http.get('/api/v1/workorder/listing/outstanding-estimations/sparepart' + createQs)
			.then((resp) => {
				
				data.show = true
				data.sparepartList = resp.data.data
				this.data[index] = data
				console.log(this.data[index])
				this.reloadTable = false
				this.reloadTable = true

			})
			.catch((err) => {
				console.log(err)
			})
        },
		generateData(numPage) {
			let filter = JSON.parse(JSON.stringify(this.filter));
			if (numPage) {
				filter.page = numPage;
			} else if (this.config) {
				filter.page = this.config.current_page;
			}

			let createQs = this.getQs(filter, false);
			this.$http
				.get("/api/v1/workorder/listing/outstanding-estimations/sparepart" + createQs)
				.then((resp) => {
					this.data = resp.data.data;
					this.config = resp.data.meta;
				})
				.catch((err) => {
					console.log(err);
				});
		},
        changePage(opt) {
			//1 First, 5 previous, 6 next, 10 last
			switch (opt) {
				case 1: //laquo - First Page
					if (this.config.current_page - 1 > 0) {
						this.generateData(1);
					} else {
						this.newError("First Page Reached!");
					}
					break;
				case 5: //lsaquo - Previous Page
					if (this.config.current_page - 1 > 0) {
						this.generateData(this.config.current_page - 1);
					} else {
						this.newError("First Page Reached!");
					}
					break;
				case 6: //rsaquo - Next Page
					if (this.config.current_page + 1 <= this.config.last_page) {
						this.generateData(this.config.current_page + 1);
					} else {
						this.newError("Last Page Reached!");
					}
					break;
				case 10: //raquo - Last Page
					if (this.config.current_page + 1 <= this.config.last_page) {
						this.generateData(this.config.last_page);
					} else {
						this.newError("Last Page Reached!");
					}
					break;
				default:
					this.newError("Pagination Error, Read Documentation");
			}
		},
		getQs(filter, flag) {
			let stringUrl = "?";
			let keys = Object.keys(filter);

			for (var i = 0; i < keys.length; i++) {
				if (flag == true && keys[i] == "type") continue;

				if (!filter[keys[i]] || filter[keys[i]] == "") continue;
				stringUrl += `${keys[i]}=${filter[keys[i]]}&`;
			}

			return stringUrl;
		},
      }
    }
  </script>
  
  <style scoped>
  
  </style>